import EmblaCarousel from './embla/embla-carousel.min';
window.EmblaCarousel = EmblaCarousel;

export default EmblaCarousel;
